import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Modal from "react-modal";

import "./style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../containers/ModalView/anim.css";

class Crypto extends Component {
  constructor() {
    super();
    this.state = {

      errors: {},
    };

  }

  render() {
    return (
      <div >

      </div>
    );
  }
}
export default connect()(withRouter(Crypto));
